const STORAGE_KEY_PREFIX = 'u3204:thinking-collapsed:';

export function u3204ThinkingPanelStorageKey(conversationId: string): string {
  return `${STORAGE_KEY_PREFIX}${conversationId}`;
}

export function u3204ReadThinkingPanelCollapsed(conversationId: string | null): boolean {
  if (!conversationId || typeof sessionStorage === 'undefined') {
    return false;
  }
  try {
    return sessionStorage.getItem(u3204ThinkingPanelStorageKey(conversationId)) === 'true';
  } catch {
    return false;
  }
}

export function u3204WriteThinkingPanelCollapsed(conversationId: string | null, collapsed: boolean): void {
  if (!conversationId || typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(u3204ThinkingPanelStorageKey(conversationId), collapsed ? 'true' : 'false');
  } catch {
    // ignore storage errors
  }
}

export function u3204ToggleThinkingPanelCollapsed(conversationId: string | null): boolean {
  const next = !u3204ReadThinkingPanelCollapsed(conversationId);
  u3204WriteThinkingPanelCollapsed(conversationId, next);
  return next;
}
